import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { taskItemResourceType } from "./tasksResourceConsts";

export const taskIdentifierStruct = createIdentifierStruct(
  taskItemResourceType
);
